var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarpTwist(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1262_5323)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0464 0H2.4024C1.76588 0 1.15543 0.252856 0.705344 0.702944C0.255256 1.15303 0.0024 1.76348 0.0024 2.4V10.392C2.5536 9.1056 6.5304 8.2704 11.2032 10.0272C13.0104 5.0736 11.1888 1.3272 10.0464 0ZM0.0024 13.9464V21.6C0.0024 22.2365 0.255256 22.847 0.705344 23.2971C1.15543 23.7471 1.76588 24 2.4024 24H10.3944C9.1056 21.4488 8.2704 17.4696 10.0296 12.792C5.076 10.9872 1.332 12.8064 0 13.9488L0.0024 13.9464ZM13.944 24H21.6C22.2365 24 22.847 23.7471 23.2971 23.2971C23.7471 22.847 24 22.2365 24 21.6V13.5984C21.4464 14.8872 17.4672 15.7248 12.792 13.9656C10.98 18.9216 12.8016 22.668 13.944 23.9976V24ZM24 10.0488C22.6704 11.1912 18.9216 13.0128 13.968 11.2032C15.7224 6.5304 14.8872 2.5536 13.5984 0.0024H21.6C22.2365 0.0024 22.847 0.255256 23.2971 0.705344C23.7471 1.15543 24 1.76588 24 2.4024V10.0488Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1262_5323"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarpTwist);
export default __webpack_public_path__ + "static/media/warp-twist.1b4b8cbc3f0ed8de319530b3b9d92e64.svg";
export { ForwardRef as ReactComponent };